import { NotificationType } from 'src/app/shared/enums/generated.enums';
import { DateHelper, DateTimeUnit } from 'src/app/shared/helpers/date.helper';
import { Notification } from '../../../shared/types/notification.type';
import { FormatHelper } from 'src/app/shared/helpers/format.helper';
import { FormatType } from 'src/app/shared/enums/format-type.enum';

export class AlertsDemoData {
  static notifications: Notification[] = [
    {
      id: '1',
      type: NotificationType.Custom,
      message: '<b>ID128 New employee onboarding</b> failed logging in due to an expired Windows password.',
      timestamp: DateHelper.subtractTime(new Date(), 10, DateTimeUnit.Minute),
      age: 10 * 60 * 1000,
      isRead: false,
    },
    {
      id: '2',
      type: NotificationType.Custom,
      message: '<b>vm003</b> has been rebooted after it stopped responding.',
      timestamp: DateHelper.subtractTime(new Date(), 27, DateTimeUnit.Minute),
      age: 27 * 60 * 1000,
      isRead: false,
    },
    {
      id: '3',
      type: NotificationType.Custom,
      message: '<b>ID376 Checkin amount receivable</b> could not be started.',
      timestamp: DateHelper.subtractTime(new Date(), 98, DateTimeUnit.Minute),
      age: 98 * 60 * 1000,
      isRead: true,
    },
    {
      id: '4',
      type: NotificationType.Custom,
      message: '<b>ID328 Purchase validation</b> has been stopped due to a low success rate (48% on the last 10 items).',
      timestamp: DateHelper.subtractTime(new Date(), 224, DateTimeUnit.Minute),
      age: 224 * 60 * 1000,
      isRead: true,
    },
    {
      id: '5',
      type: NotificationType.Custom,
      message: '<b>ID258 Order resolution SAP</b> had been stuck in stage Get next item for over 5 minutes. The process has been restarted.',
      timestamp: DateHelper.subtractTime(new Date(), 300, DateTimeUnit.Minute),
      age: 300 * 60 * 1000,
      isRead: true,
    },
    {
      id: '6',
      type: NotificationType.Custom,
      message: `<b>vm011</b> has been quarantined (until ${FormatHelper.format(DateHelper.subtractTime(new Date(), 477, DateTimeUnit.Minute), FormatType.ShortDateTime)}).`,
      timestamp: DateHelper.subtractTime(new Date(), 477, DateTimeUnit.Minute),
      age: 477 * 60 * 1000,
      isRead: true,
    },
    {
      id: '6',
      type: NotificationType.Custom,
      message: '<b>vm011</b> has been rebooted after it stopped responding.',
      timestamp: DateHelper.subtractTime(new Date(), 496, DateTimeUnit.Minute),
      age: 496 * 60 * 1000,
      isRead: true,
    },
    {
      id: '7',
      type: NotificationType.Custom,
      message: '<b>ID298 Invoice processing SAP</b> failed logging in due to an expired Windows password.',
      timestamp: DateHelper.subtractTime(new Date(), 533, DateTimeUnit.Minute),
      age: 533 * 60 * 1000,
      isRead: true,
    },
    {
      id: '8',
      type: NotificationType.Custom,
      message: 'A maintenance window (stopping all process orchestration) just ended. Pointee has resumed orchestration and is running processes according to the schedule you’ve set up.',
      timestamp: DateHelper.subtractTime(new Date(), 666, DateTimeUnit.Minute),
      age: 666 * 60 * 1000,
      isRead: true,
    },
    {
      id: '9',
      type: NotificationType.Custom,
      message: 'A maintenance window just started. Pointee will not run any processes (until 2:00 PM).',
      timestamp: DateHelper.subtractTime(new Date(), 690, DateTimeUnit.Minute),
      age: 690 * 60 * 1000,
      isRead: true,
    },
    {
      id: '10',
      type: NotificationType.Custom,
      message: `<b>ID258 Order resolution SAP</b> has been quarantined (until ${FormatHelper.format(DateHelper.subtractTime(new Date(), 1023, DateTimeUnit.Minute), FormatType.ShortDateTime)}).`,
      timestamp: DateHelper.subtractTime(new Date(), 1023, DateTimeUnit.Minute),
      age: 1023 * 60 * 1000,
      isRead: true,
    },
    {
      id: '11',
      type: NotificationType.Custom,
      message: '<b>ID258 Order resolution SAP</b> terminated.',
      timestamp: DateHelper.subtractTime(new Date(), 1024, DateTimeUnit.Minute),
      age: 1024 * 60 * 1000,
      isRead: true,
    },
    {
      id: '12',
      type: NotificationType.Custom,
      message:
        'A maintenance window (stopping all processes with the tag <i>SAP</i>) just ended. Pointee has resumed orchestration and is running those processes according to the schedule you’ve set up.',
      timestamp: DateHelper.subtractTime(new Date(), 1500, DateTimeUnit.Minute),
      age: 1500 * 60 * 1000,
      isRead: true,
    },
    {
      id: '13',
      type: NotificationType.Custom,
      message: 'A maintenance window just started. Pointee will not run any processes with the tag <i>SAP</i> until 2.30 PM.',
      timestamp: DateHelper.subtractTime(new Date(), 2000, DateTimeUnit.Minute),
      age: 2000 * 60 * 1000,
      isRead: true,
    }];
}
